export class CloseSidebar {

    static readonly type = '[Sidebar] close';

}
